<template>
  <div class="home_con">
  <common-header></common-header>
  <div class="home">
    <el-carousel trigger="click" height="418px">
      <el-carousel-item>
        <div class="banner">
          <pub-animate>
            <div class="content" v-show="showNavPic">
              <div class="left" >
                <h3 class="ft36">{{lanInfo.banner01.title}}</h3>
                <p class="ft16" :class="{'enp':lanType=='en'}">{{lanInfo.banner01.content}}</p>
              </div>
              <div class="right">
                <img class="enlarge" style="margin-top:-35px;" src="./../assets/images/banner_01.png" alt srcset>
              </div>
            </div>
          </pub-animate>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner">
          <pub-animate>
            <div class="content" v-show="showNavPic">
              <div class="left" style="width:728px;padding-top: 160px;">
                <h3 class="ft36">{{lanInfo.banner02.title}}</h3>
                <p class="ft16">{{lanInfo.banner02.content}}</p>
              </div>
              <div class="right" style="width:472px;padding-top: 32px !important;">
                <img class="enlarge" style="width:100%;height:100%;" src="./../assets/images/banner_02.png" alt srcset>
              </div>
            </div>
          </pub-animate>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner">
          <pub-animate>
            <div class="content" v-show="showNavPic" >
              <div class="left" style="width:760px;padding-top: 176px;">
                <h3 class="ft36">{{lanInfo.banner03.title}}</h3>
                <p class="ft16">{{lanInfo.banner03.content}}</p>
              </div>
              <div class="right" style="width: 427px;">
                <img class="enlarge" src="./../assets/images/banner_liulanqi.png" alt srcset>
              </div>
            </div>
          </pub-animate>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner banner-new">
          <pub-animate>
            <div class="content" style="overflow: visible;" v-show="showNavPic">
              <div class="right" style="width: 427px; padding-top:50px;">
                <img class="enlarge" src="./../assets/images/banner4_text.png" alt srcset>
              </div>
            </div>
          </pub-animate>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 技术演进 -->
    <h3 class="speech ft26">{{lanInfo.Technology}}</h3>
    <div class="speechContent">
      <div class="left">
        <div class="content" :class="{'enContent':lanType=='en'}">
          <img src="./../assets/images/home_legal.png" alt>
          <h5 class="ft24">LegalXchain</h5>
          <p class="ft12">{{lanInfo.TechnologyBlock1}}</p>
        </div>
      </div>
      <div class="middle" :class="{'enMiddle':lanType=='en'}">
        <div class="content" :class="{'enContent':lanType=='en'}">
          <img src="./../assets/images/home_fabric.png" alt>
          <h5 class="ft24">LegalFabric</h5>
          <p class="ft12">{{lanInfo.TechnologyBlock2}}</p>
        </div>
      </div>
      <div class="left">
        <div class="content" :class="{'enContent':lanType=='en'}">
          <img src="./../assets/images/home_zjzb.png" alt>
          <h5 class="ft24">{{lanInfo.TechnologyBlock3Title}}</h5>
          <p class="ft12">{{lanInfo.TechnologyBlock3}}</p>
        </div>
      </div>
    </div>
    <!-- 联盟节点成员 -->
    <div class="allianceNode">
      <h3 class="speech ft26">{{lanInfo.node}}</h3>
      <div class="allianceContent">
        <div class="item borderRightBottom">
          <img src="./../assets/images/home_flkjyy.png" alt srcset>
          <p class="ft20">{{lanInfo.LegalTech}}</p>
        </div>
        <div class="item borderRightBottom">
          <img src="./../assets/images/home_jgkjyy.png" alt srcset>
          <p class="ft20">{{lanInfo.RegTech}}</p>
        </div>
        <div class="item borderRightBottom">
          <img class="img" src="./../assets/images/home_gzjg.png" alt srcset>
          <p class="ft20">{{lanInfo.NotarialOffice}}</p>
        </div>
        <div class="item borderBottom">
          <img class="img" src="./../assets/images/home_zfjg.png" alt srcset>
          <p class="ft20">{{lanInfo.LawEnforcement}}</p>
        </div>
        <div class="item borderRight">
          <img src="./../assets/images/home_gjfjg.png" alt srcset>
          <p class="ft20">{{lanInfo.ppc}}</p>
        </div>
        <div class="item borderRight">
          <img src="./../assets/images/home-yzjgjg.png" alt srcset>
          <p class="ft20">{{lanInfo.Administration}}</p>
        </div>
        <div class="item borderRight">
          <img class="img" src="./../assets/images/home_fy.png" alt srcset>
          <p class="ft20">{{lanInfo.JudicialExpertise}}</p>
        </div>
        <div class="item">
          <img class="img" src="./../assets/images/home_qyysh.png" alt srcset>
          <p class="ft20">{{lanInfo.Enterprises}}</p>
        </div>
      </div>
    </div>
    <!-- 司法联盟链生态 -->
    <div class="judicialAlliance" :class="{'judicialAllianceSf':lanType=='en'}">
      <!-- <h3 class="speech ft26"></h3> -->
      <div class="content">
        <pub-animate enterClass="fadeInLeft" @showAnimate="showPic2_left=true">
          <div class="img" v-show="showPic2_left">
            <img class="enlarge" src="./../assets/images/home_sflmlst.png" alt>
          </div>
        </pub-animate>
        <pub-animate enterClass="fadeInRight" @showAnimate="showPic2_right=true">
          <div class="rightContent" v-show="showPic2_right">
            <p style="font-weight:550" class="ft26">{{lanInfo.LegalxchainEcolog}}</p>
            <p
              style="margin-top: 20px;color: #828080;line-height: 26px;width:610px;"
              class="ft14 textAlignJus"
            >{{lanInfo.LegalxchainEcologDscp}}</p>
            <img
              src="./../assets/images/sifast_img.png"
              v-if="lanType=='cn'"
              alt
              srcset
              style="margin-top: 20px;"
            >
            <img
              src="./../assets/images/sifast_img_en.png"
              v-if="lanType=='en'"
              alt
              srcset
              style="margin-top: 20px;"
            >
          </div>
        </pub-animate>
      </div>
    </div>
    <!-- 司法联盟链生态 -->
    <div
      class="judicialAlliance"
      style="background:#f9f9f9;"
      :class="{'enJudicialAlliance':lanType=='en'}"
    >
      <!-- <h3 class="speech ft26"></h3> -->
      <div class="content">
        <pub-animate enterClass="fadeInLeft" @showAnimate="showPic3_left=true">
          <div class="rightContent" v-show="showPic3_left">
            <p style="font-weight:550" class="ft26">{{lanInfo.Architecture}}</p>
            <p
              style="margin-top: 20px;color: #828080;line-height: 26px;width:610px;"
              class="ft14 textAlignJus"
            >{{lanInfo.ArchitectureDscp}}</p>
            <img
              src="./../assets/images/txjg_img.png"
              v-if="lanType=='cn'"
              alt
              srcset
              style="margin-top: 20px;"
            >
            <img
              src="./../assets/images/txjg_img_en.png"
              v-if="lanType=='en'"
              alt
              srcset
              style="margin-top: 20px;"
            >
          </div>
        </pub-animate>
        <pub-animate enterClass="fadeInRight" @showAnimate="showPic3_right=true">
          <div class="img" style="width:540px" v-show="showPic3_right">
            <img class="enlarge" src="./../assets/images/home_txjg.png" alt>
          </div>
        </pub-animate>
      </div>
    </div>
    <!-- 联盟链实践场景 -->
    <div class="actualCombat">
      <h3 class="speech ft26">{{lanInfo.ActualCombat}}</h3>
      <div class="actualCombatCon">
        <div class="item">
          <img src="./../assets/images/home_sfjdjg.png" alt srcset>
          <p class="ft22" style="color:#333;margin-bottom:20px;">{{lanInfo.ActualBlock1.title}}</p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock1.item1}}
          </p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock1.item2}}
          </p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock1.item3}}
          </p>
        </div>
        <div class="item">
          <img src="./../assets/images/home_sfjdjgg.png" alt srcset>
          <p class="ft22" style="color:#333;margin-bottom:20px;">{{lanInfo.ActualBlock2.title}}</p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock2.item1}}
          </p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock2.item2}}
          </p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock2.item3}}
          </p>
        </div>
        <div class="item">
          <img src="./../assets/images/home_gzc.png" alt srcset>
          <p class="ft22" style="color:#333;margin-bottom:20px;">{{lanInfo.ActualBlock3.title}}</p>
          <p class="ft14 lineHeight textCenter" :class="{'textLeft':lanType =='en'}">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock3.item1}}
          </p>
          <p class="ft14 lineHeight textCenter" :class="{'textLeft':lanType =='en'}">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock3.item2}}
          </p>
          <p class="ft14 lineHeight textCenter" :class="{'textLeft':lanType =='en'}">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock3.item3}}
          </p>
        </div>
        <div class="item" style="margin-right:0px;">
          <img src="./../assets/images/home_zxkj.png" alt srcset>
          <p class="ft22" style="color:#333;margin-bottom:20px;">{{lanInfo.ActualBlock4.title}}</p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock4.item1}}
          </p>
          <p class="ft14 lineHeight textLeft">
            <i></i>
            &nbsp;{{lanInfo.ActualBlock4.item2}}
          </p>
        </div>
      </div>
    </div>
    <!--友情链接 -->
    <div class="friendship">
      <h3 class="speech ft26">{{lanInfo.siteLinks}}</h3>
      <div class="img">
        <a v-for="item in friendshipList" :key="item.id" :href="item.src" :target="item.src!='javascript:;'?'_blank':''">
          <div :class="['backImg','img_'+item.id]"></div>
        </a>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
// 首页
export default {
  data() {
    return {
      showPic2_left: false,
      showPic2_right: false,
      showPic3_left: false,
      showPic3_right: false,
      showNavPic: false,
      //友情链接
      friendshipList:[
        {
          id:'01',
          src:"http://sspt.bjinternetcourt.gov.cn/cas/login"
        },
        {
          id:'02',
          src:"http://www.nanfangsfjd.com/"
        },
        {
          id:'03',
          src:"http://www.hzgzc.cn/"
        },
        {
          id:'04',
          src:"http://www.inic.org.cn"
        },
        {
          id:'05',
          src:"http://www.netnotary.cn"
        },
        {
          id:'06',
          src:"https://www.gzinternetcourt.gov.cn"
        },
        {
          id:'07',
          src:"http://www.gongzheng.gov.cn"
        },
        {
          id:'08',
          src:"http://www.gongzheng.com.cn"
        },
        {
          id:'09',
          src:"http://www.bjnetnotary.com/"
        },
        {
          id:'10',
          src:"http://www.notaryoffice.com.cn"
        },
        {
          id:'11',
          src:"javascript:;"
        },
        {
          id:'12',
          src:"http://www.hd-notary.com/index.xp"
        },
        
        {
          id:'13',
          src:"http://www.njscgzc.cn/"
        },
        {
          id:'14',
          src:"http://xmskygzc.com/"
        },
        {
          id:'15',
          src:"http://bhnetnotary.bhgzc.com/index"
        },
        {
          id:'16',
          src:"http://www.seastor.com.cn/"
        },
        {
          id:'17',
          src:"https://www.ip360.net.cn"
        },
        {
          id:'18',
          src:"https://www.xcontract.cn"
        },
         
        {
          id:'19',
          src:"https://cn.hyperledger.org/"
        },
        {
          id:'20',
          src:"http://www.caict.ac.cn/"
        },
        {
          id:'21',
          src:"http://www.cac.gov.cn/###"
        },
        {
          id:'22',
          src:"http://www.court.gov.cn/"
        },
        {
          id:'23',
          src:"https://www.spp.gov.cn/"
        },
       
        {
          id:'24',
          src:"http://www.mps.gov.cn/"
        },
        {
          id:'25',
          src:"http://www.ipeh.com.cn/"
        },
        {
          id:'26',
          src:"http://www.mjnotary.cn/"
        },
        {
          id:'27',
          src:"javascript:;"
        },
        {
          id:'28',
          src:"http://www.lngzc.cn/"
        },
        {
          id:'29',
          src:"http://www.bcnpo.cn/"
        },
        {
          id:'30',
          src:"http://www.fcps.org.cn/"
        },
       
      ]
    };
  },
  mounted() {
    setTimeout(() => {
      this.showNavPic = true;
    }, 100);
  },
  computed: {
    lanInfo() {
      // console.log(this.$store.getters.getLanInfo);
      return this.$store.getters.getLanInfo.index;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  methods: {}
};
</script>
<style>
.el-carousel__arrow {
  background-color: rgba(241, 243, 245, 0.11);
}
.el-carousel__arrow:hover {
  background-color: rgba(241, 243, 245, 0.11);
}
</style>

<style scoped lang="scss">
.enlarge {
  cursor: pointer;
  transition: all 0.7s ease-in-out 0s;
  &:hover {
    transform: scale(1.1, 1.1);
  }
}
.home {
  width: 100%;
  position: relative;
  z-index: 1;
  .banner {
    width: 100%;
    height: 418px;
    background: #0e285a;
    .content {
      width: 1200px;
      height: 418px;
      overflow: hidden;
      margin: 0 auto;
      .left {
        width: 728px;
        height: 418px;
        float: left;
        padding-top: 130px;
        .ft36{
          font-size: 32px;
        }
        h3 {
          color: #fff;
          font-weight: 400;
          height: 60px;
        }
        p {
          color: #fff;
          line-height: 26px;
          font-size: 14px;
        }
        .enp {
          line-height: 26px;
        }
      }
      .right {
        width: 472px;
        height: 418px;
        float: left;
        padding-top: 70px;
      }
    }
  }
  .banner-new{
    width: 100%;
    height: 418px;
    // background: #0e285a;
    background:url(../assets/images/banner4.png) no-repeat ;
    background-size: cover;
    img{
      max-width: none !important;
    }
  }
  .speech {
    text-align: center;
    color: #333;
    height: 100px;
    line-height: 100px;
  }
  .speechContent {
    width: 1200px;
    height: 255px;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 8px;
    img {
      margin-top: 8px;
    }
    .left {
      width: 376px;
      height: 221px;
      float: left;
    }

    .content {
      width: 300px;
      height: 221px;
      text-align: center;
      margin: 0 auto;
      padding: 0 26px;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 8px 30px #cac3c3;
      }
      h5 {
        color: #333;
      }
      p {
        margin-top: 15px;
        color: #606060;
        line-height: 18px;
      }
    }
    .middle {
      width: 442px;
      height: 221px;
      float: left;
      border: 1px solid #dedede;
      border-top: none;
      border-bottom: none;
    }
    .enMiddle {
      height: 240px;
    }
    .enContent {
      height: 240px;
    }
  }
  .allianceNode {
    margin-top: 26px;
    height: 514px;
    background: #f9f9f9;
    h3 {
      background: #f9f9f9;
      width: 1200px;
      margin: 0 auto;
    }
    .allianceContent {
      background: #f9f9f9;
      width: 1200px;
      overflow: hidden;
      margin: 0 auto;
      .borderRightBottom {
        border-right: 1px solid #dedede;
        border-bottom: 1px solid #dedede;
      }
      .borderRight {
        border-right: 1px solid #dedede;
      }
      .borderBottom {
        border-bottom: 1px solid #dedede;
      }
      .item {
        width: 300px;
        height: 181px;
        float: left;
        box-sizing: border-box;
        text-align: center;
        padding-top: 30px;
        img {
          cursor: pointer;
          transition: transform 3s ease;
          &:hover {
            transform: rotate(360deg);
          }
        }
        .img {
          cursor: pointer;
          transition: transform 3s ease;
          &:hover {
            transform: rotate(-360deg);
          }
        }
        p {
          margin-top: 20px;
          color: #333;
        }
      }
    }
  }

  .judicialAlliance {
    width: 100%;
    height: 526px;
    padding-top: 50px;
    .speech {
      width: 1200px;
      margin: 0 auto;
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      .img {
        width: 552px;
        height: 420px;
        float: left;
        padding: 26px;
      }
      .rightContent {
        width: 648px;
        // height: 420px;
        float: left;
      }
    }
  }
  .judicialAllianceSf {
    height: 556px;
  }
  .enJudicialAlliance {
    height: 611px;
  }
  .actualCombat {
    width: 100%;
    height: 440px;
    .actualCombatCon {
      width: 1200px;
      margin: 0 auto;
      height: 290px;
      .item {
        width: 285px;
        height: 290px;
        float: left;
        text-align: center;
        border: 1px solid #a7c5ff;
        margin-right: 20px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 8px 30px #cac3c3;
        }
        img {
          margin-top: 20px;
          margin-bottom: 20px;
        }
        .textCenter {
          text-align: center;
          color: #676767;
          line-height: 24px;
    margin-left: 12px;
        }
        .textLeft {
          text-align: left;
          color: #676767;
        line-height: 24px;
         margin-left: 34px;
        }
        i {
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #133ca4;
          position: relative;
          top: -2px;
          transform: rotate(45deg);
          -ms-transform: rotate(45deg); /* IE 9 */
          -moz-transform: rotate(45deg); /* Firefox */
          -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
          -o-transform: rotate(45deg);
        }
      }
    }
  }
  .friendship {
    width: 100%;
    background: #f9f9f9;
    overflow: hidden;
    padding-bottom: 20px;
    .img {
      width: 1200px;
      margin: 0 auto;
      .backImg {
        width: 190px;
        height: 70px;
        float: left;
        cursor: pointer;
        margin-bottom: 20px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-right: 10px;
      }
      .img_01 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/bjjcgzc_img.png");
        &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_02 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/shanghaidongfang.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_03 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/gzgzc.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      // .img_02 {
      //   background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/nfsfjd_img.png");
      //     &:hover {
      //      box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
      //   }
      // }
      // .img_03 {
      //   background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/gzszhgzc_img.png");
      //     &:hover {
      //      box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
      //   }
      // }
     .img_04 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/tjchenxin.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_05 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/bjhlwfy_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
       .img_06 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/nfsfjd_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_07 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/gzszhgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
    
      .img_08 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/zghlwfzyjy_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_09 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/gzhlwfy_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     .img_10 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/cagzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     .img_11 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/bjgxgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     .img_12 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/bjfzgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     .img_13 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/bjdfgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     .img_14 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/hbsxhgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_15 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/hngjzscqjy_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_16 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/mjgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_17 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/hnsybqgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_18 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/gdsfslngzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_19 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/fsbqbhxh_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_20 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/jssnjjscgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     
     .img_21 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/xmkygzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     .img_22 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/hbsczsbhgzc_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
     
   
      .img_23 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/hyperledger_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_24 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/zgxty_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_25 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/zgwxb_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_26{
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/zgrmjcy_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      
      .img_27 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/zggab_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_28 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/zgrmfy_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
      .img_29 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/ip360_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }
        .img_30 {
        background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/xcontract_img.png");
          &:hover {
           box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
        }
      }

    
      // .img_30 {
      //   background-image: url("./../assets/images/home/friendlink/hov_pre/newfriendlink/bjhlwfy_img.png");
      //     &:hover {
      //      box-shadow: 0px 2px 4px 2px rgba(238, 238, 238, 0.938);
      //   }
      // }
      
    }
  }
  .lineHeight{
    line-height: 14px;
  }
}
</style>




























